"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.disconnectChiliPiperIntegrationEpic = exports.createChiliPiperIntegrationEpic = exports.getChiliPiperIntegrationEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _chiliPiperIntegration = require("./chiliPiperIntegration.actions");

var getChiliPiperIntegrationEpic = function getChiliPiperIntegrationEpic(action$, state$, _ref) {
  var personalSettingsService = _ref.personalSettingsService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_chiliPiperIntegration.getChiliPiperIntegration.pending), (0, _operators.mergeMap)(function () {
    return personalSettingsService.getChiliPiperIntegration().pipe((0, _operators.mergeMap)(function (response) {
      return [_chiliPiperIntegration.getChiliPiperIntegration.fulfilled(response)];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _chiliPiperIntegration.getChiliPiperIntegration.rejected
    })), (0, _operators.takeUntil)(action$.ofType(_chiliPiperIntegration.getChiliPiperIntegration)));
  }));
};

exports.getChiliPiperIntegrationEpic = getChiliPiperIntegrationEpic;

var createChiliPiperIntegrationEpic = function createChiliPiperIntegrationEpic(action$, state$, _ref2) {
  var personalSettingsService = _ref2.personalSettingsService,
      errorHandler = _ref2.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_chiliPiperIntegration.createChiliPiperIntegration.pending), (0, _operators.mergeMap)(function (_ref3) {
    var url = _ref3.payload.url;
    return personalSettingsService.setChiliPiperIntegration(url).pipe((0, _operators.mergeMap)(function (response) {
      return [_chiliPiperIntegration.createChiliPiperIntegration.fulfilled(response)];
    }), (0, _operators.mapTo)((0, _chiliPiperIntegration.getChiliPiperIntegration)()), (0, _operators.catchError)(errorHandler({
      callbacks: _chiliPiperIntegration.createChiliPiperIntegration.rejected
    })), (0, _operators.takeUntil)(action$.ofType(_chiliPiperIntegration.createChiliPiperIntegration)));
  }));
};

exports.createChiliPiperIntegrationEpic = createChiliPiperIntegrationEpic;

var disconnectChiliPiperIntegrationEpic = function disconnectChiliPiperIntegrationEpic(action$, state$, _ref4) {
  var personalSettingsService = _ref4.personalSettingsService,
      errorHandler = _ref4.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_chiliPiperIntegration.disconnectChiliPiperIntegration.pending), (0, _operators.mergeMap)(function () {
    return personalSettingsService.deleteChiliPiperIntegration().pipe((0, _operators.mergeMap)(function (response) {
      return [_chiliPiperIntegration.disconnectChiliPiperIntegration.fulfilled(response)];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _chiliPiperIntegration.disconnectChiliPiperIntegration.rejected
    })), (0, _operators.takeUntil)(action$.ofType(_chiliPiperIntegration.disconnectChiliPiperIntegration)));
  }));
};

exports.disconnectChiliPiperIntegrationEpic = disconnectChiliPiperIntegrationEpic;
var chiliPiperIntegrationEpics = [getChiliPiperIntegrationEpic, createChiliPiperIntegrationEpic, disconnectChiliPiperIntegrationEpic];
var _default = chiliPiperIntegrationEpics;
exports.default = _default;